import styled from 'styled-components';

export const ModalText = styled.p`
  font-family: "Avenir Next";
  font-size: 16px;
  text-align: center;
`;